/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Plan_Choose_T3Inputs */

const en_dr_plan_choose_t3 = /** @type {(inputs: Dr_Plan_Choose_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand off to PRD`)
};

const id_dr_plan_choose_t3 = /** @type {(inputs: Dr_Plan_Choose_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serahkan ke PRD`)
};

/**
* | output |
* | --- |
* | "Hand off to PRD" |
*
* @param {Dr_Plan_Choose_T3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_plan_choose_t3 = /** @type {((inputs?: Dr_Plan_Choose_T3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Plan_Choose_T3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_plan_choose_t3(inputs)
	return en_dr_plan_choose_t3(inputs)
});